<div class="main-header-container">
  <img
    [src]="organizationLogo"
    class="loc-logo"
    aria-label="organization logo"
  />
</div>
